import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { ToastManager } from '@features';
import { MassAddInAlbumModal } from '@features/MassAddInAlbumModal';
import { Flex, Icon, UiButton, UiText } from '@shared/ui';

import cls from './MassSelection.module.css';
import { useMassSelection } from './useMassSelection';

interface MassSelectionProps {
    classes?: string;
}

export const MassSelection = ({ classes }: MassSelectionProps) => {
    const {
        isActiveMassSelectMode,
        activeMassSelectModeHandle,
        selectedMassMediaIds,
        onALLSelectedMassMediaIds,
        isOpen,
        open,
        close,
    } = useMassSelection();

    const { t } = useTranslation();

    return (
        <>
            <Flex gap={12} className={cn(cls.MassSelection, [classes])}>
                {isActiveMassSelectMode && (
                    <UiButton
                        onClick={() => activeMassSelectModeHandle(false)}
                        btnColor="secondary"
                        btnText={t('button.cancelSelect.text')}
                    />
                )}
                {!isActiveMassSelectMode && (
                    <UiButton
                        onClick={() => activeMassSelectModeHandle(true)}
                        startIcon={<Icon iconName="checkboxes" />}
                        btnColor="light"
                        btnText={t('button.select.text')}
                    />
                )}
                {isActiveMassSelectMode && (
                    <UiButton
                        onClick={onALLSelectedMassMediaIds}
                        startIcon={<Icon iconName="checkboxes" />}
                        btnColor="light"
                        btnText={t('button.selectAll.text')}
                    />
                )}

                <UiButton
                    onClick={open}
                    disabled={!isActiveMassSelectMode || !selectedMassMediaIds.length}
                    className={cls.addAlbumButton}
                    btnText={t('MassSelection.return.MassSelection.UiButton.addInAlbum.btnText')}
                />
                {isActiveMassSelectMode && (
                    <Flex gap={4}>
                        <UiText classes={cls.selectedTitle}>
                            {t('MassSelection.return.Flex.selectedTitle')}:
                        </UiText>
                        <UiText classes={cls.selectedCount}>{selectedMassMediaIds.length}</UiText>
                    </Flex>
                )}
            </Flex>
            {isOpen && <MassAddInAlbumModal isOpen={isOpen} onClose={close} />}
            <ToastManager
                toastPosition="left"
                pushStyles={cls.toastStyles}
                renderToast={({ isToastShow, positionStyles, text }) => (
                    <div
                        className={cn(cls.customToastContainer, isToastShow && cls.isOpen)}
                        style={positionStyles}
                    >
                        <Icon iconName="isChecked" />
                        <span className={cls.customToastContent}>{text}</span>
                    </div>
                )}
            />
        </>
    );
};
